import {
  Routes, Route, BrowserRouter as Router, Link,
} from 'react-router-dom';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Nav from './components/Nav/Nav';
import Footer from './components/Footer';
import Home from './components/Home/Home';

import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import Logout from './components/auth/Logout';

// Inventory related imports

import InventoryLayout from './components/modules/inventory/InventoryLayout';
import InventoryDashboard from './components/modules/inventory/InventoryDashboard';
import AddNewProduct from './components/modules/inventory/AddNewProduct';
import UpdateProduct from './components/modules/inventory/UpdateProduct';
import InventoryTableContainer from './components/modules/inventory/InventoryTableContainer';
import StockMovementLog from './components/modules/inventory/StockMovementLog';
import ProductInfo from './components/modules/inventory/ProductInfo';
import Purchase from './components/modules/inventory/Purchase';
import Issue from './components/modules/inventory/Issue';
import SearchProduct from './components/modules/inventory/SearchProduct';
import FutureImplementPlan from './components/modules/inventory/FutureImplementPlan';
import InventoryOrders from './components/modules/inventory/order/OrderHistory';
import KitchenOrders from './components/modules/inventory/order/KitchenOrders';
// Imports from Sales module
import SalesLayout from './components/modules/sales/SalesLayout';
import SalesDashboard from './components/modules/sales/SalesDashboard';
import SalesAnalytics from './components/modules/sales/SalesAnalytics';
import SalesEntry from './components/modules/sales/SalesEntry';
import UpdateSalesEntry from './components/modules/sales/UpdateSalesEntry';
import SalesList from './components/modules/sales/SalesList';
import SalesScreen from './components/modules/sales/SalesScreen';
import SalesFuturePlan from './components/modules/sales/FutureImplementPlan';
import SalesReturnsLayout from './components/modules/sales/SalesReturnsLayout';
// import CustomersLayout from './components/modules/sales/CustomersLayout';

//  POS related imports
import PosLayout from './components/modules/pos/PosLayout';
import PosDashboard from './components/modules/pos/PosDashboard';
import POSScreen from './components/modules/pos/POSScreen';
import PosReturns from './components/modules/pos/PosReturns';

// Module-Shared  comonents imports
import TransactionProvider from './contexts/TransactionContext';

// import Payroll from './components/modules/accounts/Old_Payroll';
// import IncomeList from './components/modules/accounts/IncomeList';
// import ExpenseList from './components/modules/accounts/ExpenseList';
// import CashFlowOverview from './components/HR-Accounts/CashFlowOverview';
import EmployeeList from './components/modules/hr/EmployeeList';
import AttendanceSheet from './components/modules/hr/AttendanceSheet';
import NewEmployeeForm from './components/modules/hr/NewEmployeeForm';
import PayrollSettings from './components/modules/hr/PayrollSettings';
import Payroll from './components/modules/hr/Payroll';
import PayrollMonthly from './components/modules/hr/PayrollMonthly';
import HrDashboard from './components/modules/hr/HrDashboard';
import Settings from './components/settings/Settings';
import ErrorPage from './components/ErrorPage/ErrorPage';

// Accounts related imports
import Accounts from './components/modules/accounts/Accounts';

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <AuthProvider>
        <TransactionProvider>
          <Router>
            <Nav />
            <main className="flex-grow">
              <div className="w-full flex justify-center mb-6">
                <Link
                  to="/"
                  className="text-blue-500 text-2xl hover:underline flex-center"
                >
                  Home
                </Link>
              </div>
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/" element={<Home />} />

                {/* Protected routes */}

                {/* HR Module */}
                <Route path="/hr-dashboard" element={<ProtectedRoute><HrDashboard /></ProtectedRoute>} />
                <Route path="/payroll-monthly" element={<ProtectedRoute><PayrollMonthly /></ProtectedRoute>} />

                {/* Inventory Module */}
                <Route path="/inventory" element={<ProtectedRoute><InventoryLayout /></ProtectedRoute>}>
                  <Route path="dashboard" element={<InventoryDashboard />} />
                  <Route path="add-new-product" element={<AddNewProduct />} />
                  <Route path="update-product/:id" element={<UpdateProduct />} />
                  <Route path="inventory-table" element={<InventoryTableContainer />} />
                  <Route path="stock-movement-log" element={<StockMovementLog />} />
                  <Route path="product/:id" element={<ProductInfo />} />
                  <Route path="purchase" element={<Purchase />} />
                  <Route path="issue" element={<Issue />} />
                  <Route path="search-product" element={<SearchProduct />} />
                  <Route path="orders" element={<InventoryOrders />} />
                  <Route path="kitchen-orders" element={<KitchenOrders />} />
                  <Route path="future-implement-plans" element={<FutureImplementPlan />} />
                </Route>

                {/* Sales Module */}
                <Route path="/sales" element={<ProtectedRoute><SalesLayout /></ProtectedRoute>}>
                  <Route path="dashboard" element={<SalesDashboard />} />
                  <Route path="analytics" element={<SalesAnalytics />} />
                  <Route path="entry" element={<SalesEntry />} />
                  <Route path="update-entry/:orderId" element={<UpdateSalesEntry />} />
                  <Route path="transactions" element={<SalesList />} />
                  <Route path="sales-screen" element={<SalesScreen />} />
                  <Route path="future-plans" element={<SalesFuturePlan />} />
                  <Route path="returns/*" element={<SalesReturnsLayout />} />
                </Route>

                {/* POS Module */}
                <Route path="/pos" element={<ProtectedRoute><PosLayout /></ProtectedRoute>}>
                  <Route path="dashboard" element={<PosDashboard />} />
                  <Route path="pos-screen" element={<POSScreen />} />
                  <Route path="returns/*" element={<SalesReturnsLayout />} />
                  <Route path="pos-returns" element={<PosReturns />} />
                </Route>

                {/* Accounts Module */}
                {/* <Route path="/accounts-dashboard" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />
                <Route path="/income-list" element={<ProtectedRoute><IncomeList /></ProtectedRoute>} />
                <Route path="/expense-list" element={<ProtectedRoute><ExpenseList /></ProtectedRoute>} /> */}
                <Route path="/accounts" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />

                {/* HR Module */}
                <Route path="/employee-list" element={<ProtectedRoute><EmployeeList /></ProtectedRoute>} />
                <Route path="/attendance-sheet" element={<ProtectedRoute><AttendanceSheet /></ProtectedRoute>} />
                <Route path="/new-employee" element={<ProtectedRoute><NewEmployeeForm /></ProtectedRoute>} />
                <Route path="/payroll-settings" element={<ProtectedRoute><PayrollSettings /></ProtectedRoute>} />
                <Route path="/payroll" element={<ProtectedRoute><Payroll /></ProtectedRoute>} />

                {/* Settings */}
                <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

                {/* Public Info Pages */}
                <Route path="/about" element={<div>About Us</div>} />
                <Route path="/disclaimer" element={<div>Disclaimer</div>} />
                <Route path="/contact-us" element={<div>Contact Us</div>} />

                {/* Error Page */}
                <Route path="/*" element={<ErrorPage />} />
              </Routes>

              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </main>
            <Footer />
          </Router>
        </TransactionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
